export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"

export const FORGET_PASSWORD_VERIFICATION = "FORGET_PASSWORD_VERIFICATION"
export const FORGET_PASSWORD_VERIFICATION_SUCCESS = "FORGET_PASSWORD_VERIFICATION_SUCCESS"
export const FORGET_PASSWORD_VERIFICATION_ERROR = "FORGET_PASSWORD_VERIFICATION_ERROR"
